import { useState, useMemo, useEffect, useRef } from "react";
import { ReactComponent as Warning } from "../../../../assets/images/icon_svg/warning.svg";
import { ReactComponent as Arrow } from "../../../../assets/images/icon_svg/link_page.svg";
import TableGrid from "../../../../Components/common/TableGrid";
import { useSelector } from "react-redux";
import TableFilters from "../../../../Components/common/TableGrid/TableFilters"; 
import TableTabs from "../../../../Components/common/TableGrid/TableTabs";  

import { CallApi, CommonModal, getTodayDateTime } from "../../../../Components/common/CommonFunctions";
import { toast } from 'react-toastify';
import Popup from 'reactjs-popup';
import { useDispatch } from "react-redux";
import { useGetCargoDamageForwardersQuery, useToggleSlotStatusMutation, useTruckOrderShipmentQuery } from "../../../../redux/services/SPL";
import { clearAllTableFilters, onChangeFilters, onTabChange, clearSelectedRowsData } from "../../../../redux/features/table/tableSlice";
// import TableTabs from "../../../../Components/common/TableGrid/TableTabs";

const Shipments = ({ detID, onTruckChange }) => {

  const isMounted = useRef(false);
  const [warehouse, setWarehouse] = useState([]);
  const [org, setOrg] = useState([]);
  const [disLoading, setDisLoading] = useState(false);
  //  const detID = localStorage.getItem('TODetails');

  const { pageDetails, filters, sortby, selectedRows, tab } = useSelector((state) => state.table);

   const buildFilterParams = (filtersObj) => {
        const params = {};
        Object.entries(filtersObj).forEach(([key, value]) => {
            if (value === undefined || value === null || value === "" || (Array.isArray(value) && value.length === 0)) {
                return;
            }
            if (Array.isArray(value)) {
                params[key] = JSON.stringify(value);
            } else {
                params[key] = value;
            }
        });
        if (Object.keys(params).length > 0) {
            params.is_filter = true;
        }
        return params;
    };

  const queryParams = useMemo(() => {
    const filterParams = buildFilterParams(filters);

    const params = {
      ...filterParams,
      id: detID,
      pagenum: pageDetails.pagenum,
      pagesize: pageDetails.pagesize,
      recordstartindex: pageDetails.recordstartindex,
      recordendindex: pageDetails.recordendindex,
    };

    if (sortby?.sortdatafield) {
      params.sortdatafield = sortby.sortdatafield;
      params.sortorder = sortby.sortorder;
    }

    // if (tab?.value && tab.value !== "all" && tab.key) {
    //   params[tab.key] = tab.value;
    // }
    return params;
  }, [filters, pageDetails, sortby]);

  const { data: myData, isFetching, refetch } = useTruckOrderShipmentQuery(queryParams, {
    skip: pageDetails.pagesize === 0,
    refetchOnMountOrArgChange: true,
  });

  // const fetchWarehousOrgnaziation = async () => {
  //   CallApi({
  //     endPoint: `trip-management/slot-warehouse-organizations`,
  //     method: 'get',
  //     onSuccess: (res) => {
  //       const innerData = res.data.response_data;
  //       setOrg(innerData?.organization);
  //       setWarehouse(innerData?.warehouses);
  //     },
  //     onError: (msg) => toast.error(msg)
  //   });
  // };
  useEffect(() => {
    if (isMounted.current) return;
    // fetchWarehousOrgnaziation();
    dispatch(onTabChange({ key: 'tab', value: "A" }));
    isMounted.current = true;
  }, []);

  const filtersConfig = [
    {
      type: "input",
      field: "awb_no",
      placeholder: "Search AWB No.",
    },
  ];
  const tabsConfig = [
    { label: "All", value: "all", paramKey: null },
    { label: "Open", value: "A", paramKey: "tab" },
    { label: "Archive", value: "R", paramKey: "tab" },
  ];

  const dispatch = useDispatch();
  const isNegative = (value) => value?.includes("-") && value?.includes("(");
  const columns = [
    { label: "", field: "awb_no", enableSearch: false, cls: 'tw-6',
       renderCell: (row) => {
        if(row?.discrepancy){
          return(<><Warning /></>)
        }
       }
     },
    { label: "AWB No", field: "awb_no", enableSearch: false, cls: 'tw-5' },
    { label: "Pcs", field: "total_pcs", enableSearch: false, cls: 'tw-5' },
    { label: "Trucker Planned", field: "planned_pcs", enableSearch: false, cls: 'tw-5',},
    { label: "Other Truck(s)", field: "other_trucks", enableSearch: false, cls: 'tw-5',
      renderCell: (row) => {
        const trucks = row?.other_trucks ?? [];
        if (!trucks.length) {
          return '-';
        }
        return (
          <Popup
            trigger={
              <span className="others_truck">
                {trucks.length} truck{trucks.length > 1 ? 's' : ''}
              </span>
            }
            className="poparrow"
            position="right top"
            on={['hover', 'focus']}
            arrow={true}
          >
            <div className="shipmentPopup">
              <h3 className="text-center">
                Also planned on {trucks.length} other truck{trucks.length > 1 ? 's' : ''}
              </h3>
              {trucks.map((truck, index) => {
                return (
                  <div className="segments-block" key={index}>
                    <span>
                      <strong>{truck?.truck_flight_no || '-'}</strong>
                      {' / '}
                      {truck?.truck_std || '-'}
                      {' / '}
                      {/* {truck?.board_point || '-'}
                      {' - '}
                      {truck?.off_point || '-'}
                      {' / '}
                      {truck?.awb_no || '-'} */}
                      {/* {' / '} */}
                      {truck?.total_pcs || 0} pcs
                    </span>
                    <button
                      className="ms-2"
                      onClick={() => onTruckChange(truck)}
                    >
                      Open Truck <Arrow width={14} height={14} />
                    </button>
                  </div>
                );
              })}
            </div>
          </Popup>
        );
      },
    },
    {
      label: "Received (Loading)", field: "loading_received_display", enableSearch: false, cls: "tw-9",
      renderCell: (row) => (
        <span className={row?.loading_received_display?.includes("-") && row?.loading_received_display?.includes("(") ? "red_text" : ""}>
          {row?.loading_received_display}
        </span>
      ),
    },
    {
      label: "MAN", field: "loading_man_display", enableSearch: false, cls: "tw-6",
      renderCell: (row) => (
        <span className={row?.loading_man_display?.includes("-") && row?.loading_man_display?.includes("(") ? "red_text" : ""}>
          {row?.loading_man_display}
        </span>
      ),
    },
    {
      label: "DEP", field: "loading_dep_display", enableSearch: false, cls: "tw-5",
      renderCell: (row) => (
        <span className={row?.loading_dep_display?.includes("-") && row?.loading_dep_display?.includes("(") ? "red_text" : ""}>
          {row?.loading_dep_display}
        </span>
      ),
    },
    {
      label: "RCF (Unloading)", field: "unloading_rcf_display", enableSearch: false, cls: "tw-9",
      renderCell: (row) => (
        <span className={row?.unloading_rcf_display?.includes("-") && row?.unloading_rcf_display?.includes("(") ? "red_text" : ""}>
          {row?.unloading_rcf_display}
        </span>
      ),
    },
    { label: "Weight", field: "total_weight", enableSearch: false, cls: 'tw-5' },
    { label: "Volume", field: "total_volume", enableSearch: false, cls: 'tw-5' },
    { label: "Inbound Flight No.", field: "inbound_flight_no", enableSearch: false, cls: 'tw-5' },
    { label: "Inbound Flight Date", field: "inbound_flight_date", enableSearch: false, cls: 'tw-5',
      renderCell: (row) => {
      const date = new Date(row?.inbound_flight_date);
      return (
        <>
          {row?.inbound_flight_date?.slice(0, 16)}
        </>
      );},
     },
    { label: "Inbound Flight ULD", field: "units_loaded", enableSearch: false, cls: 'tw-5' },
    { label: "SHC", field: "shc", enableSearch: false, cls: 'tw-8' },
    { label: "Last Update", field: "updated_at", enableSearch: false,
      renderCell: (row) => {
      const date = new Date(row.updated_at);
      return (
        <>
          {row.updated_at.slice(0, 16)}
        </>
      );},
    }
  ];

  return (
    <>
      {/* {console.log("formData", formData)} */}
      {disLoading ? <div className='mvt loader-container h-100'><span className='mvt loader' style={{ left: '48%', top: '48%' }}></span></div> : ''}
      <div>
       <div className="d-flex gap-2 align-items-center mb-3">
  
          <TableFilters filtersConfig={filtersConfig} />

          <div className="d-flex align-items-center gap-3 shpmntawbTab">
            <span><b>{myData?.total_awbs}</b> AWBs</span>
            <span><b>{myData?.total_pcs}</b> pcs</span>
            <span><b>{myData?.total_weight}</b> kg</span>
            <span><b>{myData?.total_volume}</b> m³</span>
            <span ><Warning width={16} height={16} /> <b>{myData?.total_discrepancy}</b>  Discrepancy</span>
          </div>

        </div>

        <div>
          <TableGrid
            columns={columns}
            rows={myData?.Rows}
            totalRecords={myData?.TotalRows || 0}
            onClickRow={(row) => {
              console.log("Clicked Row:", row);
            }}
            loading={isFetching}
            rowKey="id"
          />
        </div>
      </div>
    </>
  )
}

export default Shipments